<template>
  <div class="el-badge item">
    <slot>
      <el-button size="small" :style="{'background':btnBgColor,'color':btnColor,'width':btnWidth,'fontSize':fontSize}"  @click="btnClick">{{btnText}}</el-button>
    </slot>
    <sup v-if="isShowBadge" class="el-badge__content  is-fixed" style="cursor: pointer;" :style="{'background':badgeBgColor,'color':badgeColor}" @click="badgeClick">{{badgeText}}</sup>
  </div>
</template>
<script>
  export default {
    props: {
      isShowBadge:{
        type:Boolean,
        default:true
      },
      btnBgColor: {
        type: String,
        default: ''
      },
      fontSize:{
        type:String
      },
      btnWidth:{
        type:String,
        default:'100%'
      },
      btnColor: {
        type: String,
        default: "#000"
      },
      btnText: {
        type: String,
        default: 'test'
      },
      badgeBgColor: {
        type: String,
        default: 'red'
      },
      badgeColor: {
        type: String,
        default: '#fff'
      },
      badgeText: {
        type: String,
        default: 'X'
      },
      params:{
        type:Object,
        default:null
      }
    },
    methods: {
      btnClick() {
        this.$emit("btnClick",this.params)
      },
      badgeClick() {
        debugger
        this.$emit("badgeClick",this.params)
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/basic/FwBadge.vue